/* eslint-disable */
import { handleTimeInputs } from './timeToHandler.js';
import inputHandlers from '../../../services/inputHandlers/index.js';
const $form = $('#become-a-partner');
const $successMessage = $('#become-a-partner-success-message');
const $budgetInput = $form.findOne('#budget');
const $peopleInput = $form.findOne('#people');
const $nameInput = $form.findOne('#name');
const $areaNeighbourhoodInput = $form.findOne('#area-neighbourhood');
const $zeroPeopleNotice = $form.findAny('.js-zero-people-notice');
const $smallBudgetNotice = $form.findAny('.js-small-budget-notice');
const $bigBudgetNotice = $form.findAny('.js-big-budget-notice');
const $zeroBudgetNotice = $form.findAny('.js-zero-budget-notice');
const minBudget = parseInt($budgetInput.attr('data-minBudget'), 10) || 0;
const maxBudget = parseInt($budgetInput.attr('data-maxBudget'), 10) || 99999;

const saveForm = (formData) => {
  const user = window.__TGV_USER_DATA || {};

  const data = {
    ...formData,
    submissionDate: (new Date()).toISOString(),
    referrer: document.referrer,
    userType: user.type,
    userCountry: user.locationCountryCode,
    userId: user.id,
  };

  App.track.all({
    category: 's-tagvenue-business',
    action: 'form-submission',
    meta: JSON.stringify(data, null, 2),
  });

  $.ajax({
    type: 'POST',
    url: window.TGV_ZAPIER_URL,
    data: JSON.stringify(data),
    dataType: 'json',
  });
};

const toggleValidity = (el, isValid) => {
  const $formGroup = $(el).parents('.form-group');
  $formGroup.toggleClass('has-error', !isValid);
  $formGroup.find('.c-form-field-error').toggle(!isValid);
};

const makeFieldInvalid = (el) => {
  toggleValidity(el, false);
};

const makeFieldValid = (el) => {
  toggleValidity(el, true);
};

const showFormSubmittedAlert = () => {
  $successMessage.removeClass('hidden');
  scrollTo($successMessage);
};

const convertCurrencyToInt = (value) => {
  return value.replace(/\D/gmi, '');
};


const isBudgetBig = () => {
  return parseInt(convertCurrencyToInt($budgetInput.val()), 10) > maxBudget;
};

const isBudgetSmall = () => {
  const val = parseInt(convertCurrencyToInt($budgetInput.val()), 10);
  return val > 0 && val < minBudget;
};

const isBudgetZero = () => {
  return convertCurrencyToInt($budgetInput.val()) < 1;
}

const isPeopleFieldZero = () => {
  return convertCurrencyToInt($peopleInput.val()) < 1;
}

const isNameFieldMadeWithEmptySpaces = () => {
  const regex = /^\s*$/;
  return regex.test($nameInput.val());
}

const shouldCheckBudget = () => $smallBudgetNotice && $bigBudgetNotice && $zeroBudgetNotice;
const shouldCheckPeople = () => $zeroPeopleNotice;

const validateTimeTo = (element) => {
  const startOfDay = '06:00';
  const value = element.value;
  const timeFromValue = document.getElementById('time-from').value;

  if (value < startOfDay && timeFromValue > startOfDay) {
    return true; // is valid
  }
  if (value <= timeFromValue) {
    makeFieldInvalid(element);
    return false;
  }
  return true;
};

const validateEventDate = (element) => {
  const value = element.value;
  const dateParts = value.split('/');
  if (dateParts.length !== 3) {
    makeFieldInvalid(element);
    return false;
  }
  const date = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
  if (date.getTime() < Date.now()) {
    makeFieldInvalid(element);
    return false;
  }
  return true;
}

const validateMinBudget = element => {
  const value = parseInt(element.value, 10);
  if (value > 0 && value < minBudget) {
    makeFieldInvalid(element);
    return false;
  }
  return true;
};

const validateMaxBudget = element => {
  const value = parseInt(element.value, 10);
  if (value > maxBudget) {
    makeFieldInvalid(element);
    return false;
  }
  return true;
};

const validateBudgetNotZero = element => {
  if (isBudgetZero()) {
    makeFieldInvalid(element);
    return false;
  }
  return true;
}

const validatePeopleFieldNotZero = element => {
  if (isPeopleFieldZero()) {
    makeFieldInvalid(element);
    return false;
  }
  return true;
}

const validateNameFieldNotMadeFromWhitespaces = element => {
  if (isNameFieldMadeWithEmptySpaces()) {
    makeFieldInvalid(element);
    return false;
  }
  return true;
}

const validateForm = () => {
  let isValid = true;
  $form.find('.form-control').each((i, el) => {
    switch(el.id) {
      case 'time-to':
        isValid = validateTimeTo(el) && isValid;
        return;
      case 'event-date':
        isValid = validateEventDate(el) && isValid;
        return;
      case 'budget':
        isValid = validateBudgetNotZero(el) && validateMinBudget(el) && validateMaxBudget(el) && isValid;
        return;
      case 'people':
        isValid = validatePeopleFieldNotZero(el) && isValid;
        return;
      case 'name':
        isValid = validateNameFieldNotMadeFromWhitespaces(el) && isValid;
    }
  });
  return isValid;
};

const isFormValid = () => {
  return $form[0].checkValidity();
};

const scrollTo = (element) => {
  const offsetTop = element.offset().top;

  $('html, body').animate({
    scrollTop: offsetTop,
  }, 500);
};

const parseValue = (el) => {
  if (el.name === 'budget') {
    return convertCurrencyToInt(el.value);
  }
  if (el.name === 'phone') {
    return el.value.trim();
  }
  return el.value;
};

const getFormData = () => {
  const data = $form.serializeArray();

  // convert to object
  return data.reduce((mem, el) => {
    if (!mem[el.name]) {
      mem[el.name] = parseValue(el);
    } else {
      // handle checkboxes
      mem[el.name] += `; ${el.value}`;
    }
    return mem;
  }, {});
};

const onFormSubmit = (event) => {
  event.preventDefault();

  if (isNameFieldMadeWithEmptySpaces()) {
    $nameInput.val('');
  }

  return false;
};

const onFormSubmitClick = () => {
  if (!validateForm()) {
    scrollTo($form);
    return false;
  }

  const formData = getFormData();
  saveForm(formData);

  // give user an impression it was sent
  // normally would appear too immediate looking fake
  setTimeout(showFormSubmittedAlert, 300);
  return false;
};

const onFormInputChange = (event) => {
  if (event.target.checkValidity() === true) {
    makeFieldValid(event.target);
  }
};

const onBudgetChange = () => {
  if (!shouldCheckBudget()) {
    return;
  }
  const budget = parseInt($budgetInput.val(), 10);

  if (!$budgetInput.val()) {
    $smallBudgetNotice.hide();
    $smallBudgetNotice.parents('.form-group').removeClass('has-error');
    $bigBudgetNotice.hide();
    return;
  }

  if (isBudgetBig()) {
    $smallBudgetNotice.hide();
    $smallBudgetNotice.parents('.form-group').removeClass('has-error');
    $bigBudgetNotice.show();
    $bigBudgetNotice.parents('.form-group').addClass('has-error');
  } else if (isBudgetSmall()) {
    $smallBudgetNotice.show();
    $smallBudgetNotice.parents('.form-group').addClass('has-error');
    $bigBudgetNotice.hide();
    $bigBudgetNotice.parents('.form-group').removeClass('has-error');
  } else {
    $smallBudgetNotice.hide();
    $smallBudgetNotice.parents('.form-group').removeClass('has-error');
    $bigBudgetNotice.hide();
    $bigBudgetNotice.parents('.form-group').removeClass('has-error');
  }

  if (isBudgetZero()) {
    $zeroBudgetNotice.show();
    $zeroBudgetNotice.parents('.form-group').addClass('has-error');
  } else {
    $zeroBudgetNotice.hide();
    $zeroBudgetNotice.parents('.form-group').removeClass('has-error');
  }
};

const onPeopleChange = () => {
  if (!shouldCheckPeople()) {
    return;
  }
  if (isPeopleFieldZero()) {
    $zeroPeopleNotice.show();
    $zeroPeopleNotice.parents('.form-group').addClass('has-error');
  } else {
    $zeroPeopleNotice.hide();
    $zeroPeopleNotice.parents('.form-group').removeClass('has-error');
  }
}

// scroll to form buttons
$('.js-scroll-to-business-form').on('click', function() {
  scrollTo($form);
});

$budgetInput.on('change', onBudgetChange);
$peopleInput.on('change', onPeopleChange);
$form.on('submit', onFormSubmit);

const eventDateInput = document.getElementById('event-date');

App.es6.shared.pikaday({
  element: eventDateInput,
  weekStart: 1,
  uiDateFormat: 'MM/DD/YYYY',
});

App.es6.shared.default_form_handler({
  formClass: '.become-a-partner',
  onSuccessfulValidation: onFormSubmitClick,
}).init();

inputHandlers.date(eventDateInput);
inputHandlers.number(document.getElementById('people'));
inputHandlers.number(document.getElementById('budget'));
inputHandlers.phone(document.getElementById('phone'));

const timeFromInput = document.querySelector('#time-from');
const timeToInput = document.querySelector('#time-to');
handleTimeInputs(timeFromInput, timeToInput, (timeToEl) => {
  makeFieldValid(timeToEl);
});

// prevent typing numbers in area / neighbourhood field
$areaNeighbourhoodInput.on('keydown', function(e) {
  if ((/\d/g).test(e.key)) {
    e.preventDefault();
  }
});
